import React from 'react';
import styled, { keyframes, css } from 'styled-components';

// Headlight animation
const headlightGlow = keyframes`
  0% { box-shadow: 0 0 5px 2px rgba(255, 255, 255, 0.5); }
  50% { box-shadow: 0 0 10px 3px rgba(255, 255, 255, 0.7); }
  100% { box-shadow: 0 0 5px 2px rgba(255, 255, 255, 0.5); }
`;

// Wheel rotation animation
const wheelRotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

// Car bounce animation
const carBounce = keyframes`
  0% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
  100% { transform: translateY(0); }
`;

// Car move animation
const carMove = keyframes`
  0% { transform: translateX(-80px); }
  50% { transform: translateX(80px); }
  100% { transform: translateX(-80px); }
`;

const CarContainer = styled.div`
  position: relative;
  width: 80px;
  height: 40px;
  margin: 0 auto;
  transition: all 0.3s ease;
  animation: ${carMove} 6s ease-in-out infinite;
`;

const CarBody = styled.div`
  position: absolute;
  width: 60px;
  height: 20px;
  background: #00e1c7;
  border-radius: 10px 10px 5px 5px;
  top: 10px;
  left: 10px;
  
  animation: ${carBounce} 1s ease-in-out infinite;
`;

const CarRoof = styled.div`
  position: absolute;
  width: 40px;
  height: 12px;
  background: #00e1c7;
  border-radius: 10px 10px 0 0;
  top: 0;
  left: 20px;
`;

const CarWindow = styled.div`
  position: absolute;
  width: 10px;
  height: 8px;
  background: #0a1a1f;
  border-radius: 2px;
  top: 2px;
  left: ${props => props.$position}px;
`;

const Wheel = styled.div`
  position: absolute;
  width: 12px;
  height: 12px;
  background: #0a1a1f;
  border-radius: 50%;
  bottom: 0;
  left: ${props => props.$position}px;
  
  &::after {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    background: #333;
    border-radius: 50%;
    top: 3px;
    left: 3px;
  }
  
  animation: ${wheelRotate} 1s linear infinite;
`;

const Headlight = styled.div`
  position: absolute;
  width: 4px;
  height: 4px;
  background: #fff;
  border-radius: 50%;
  top: 15px;
  left: ${props => props.$position === 'front' ? '70px' : '6px'};
  
  animation: ${headlightGlow} 1.5s ease-in-out infinite;
`;

const AnimatedCar = () => {
  return (
    <CarContainer>
      <CarBody />
      <CarRoof />
      <CarWindow $position={25} />
      <CarWindow $position={40} />
      <Wheel $position={15} />
      <Wheel $position={50} />
      <Headlight $position="front" />
      <Headlight $position="back" />
    </CarContainer>
  );
};

export default AnimatedCar;